export default {
  sm: `
  Fast recovery
  and follow-up actions
  `,
  xxl: `
  Fast recovery
  and follow-up
  actions
  `
};  